import { RussianRuble, Percent, CheckCircle, Save } from 'lucide-react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { authFetch } from '../utils/authFetch';
import { useState, useEffect } from 'react';
import { API_URL } from '../config';
import { Button } from './ui/button';


export default function AdminSettings() {
    const [settingsData, setSettingsData] = useState({
        bookPrice: 0,
        subPrice: 0,
        platformPercent: 0,
        refPercent: 0
    });
    const [isEditingSettings, setIsEditingSettings] = useState(false);
    const [settingsSaved, setSettingsSaved] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchSettings = async () => {
        try {
        const token = localStorage.getItem("token");
        const res = await authFetch(`${API_URL}/settings/admin/settings`, {
            headers: {
            "Authorization": `Bearer ${token}`
            }
        });
        if (!res.ok) throw new Error(`Ошибка ${res.status}`);
        const data = await res.json();
        setSettingsData({
            bookPrice: data.settings.book_price,
            subPrice: data.settings.sub_price,
            platformPercent: data.settings.platform_percent,
            refPercent: data.settings.ref_percent
        });
        } catch (err) {
        console.error(err);
        setError("Не удалось загрузить настройки");
        } finally {
        setLoading(false);
        }
    }; 


    // 2) Загружаем сразу при монтировании
      useEffect(() => {
        fetchSettings();
      }, []);


    const handleSettingsSave = async () => {
        try {
          const token = localStorage.getItem("token");
          const res = await authFetch(`${API_URL}/settings/admin/settings`, {
            method: "PATCH",
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(settingsData)
          });
          if (!res.ok) throw new Error(`Ошибка ${res.status}`);
          setSettingsSaved(true);
          setIsEditingSettings(false);
          setTimeout(() => setSettingsSaved(false), 3000);
        } catch (err) {
          console.error(err);
          setError("Не удалось сохранить изменения");
        }
      };


  return (
    <div className="p-3 sm:p-6 space-y-6 max-w-6xl mx-auto">
        <div className="text-center space-y-2">
            <h1 className="gradient-text text-2xl sm:text-3xl font-bold">
                Настройки сайта
            </h1>
            <p className="text-gray-600 text-sm sm:text-base">
                Управляйте ценами и процентами с продаж
            </p>
        </div>

        {/* Успешно сохранили профиль */}
        {settingsSaved && (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <div className="flex items-center gap-2">
                    <CheckCircle className="h-5 w-5 text-green-600" />
                    <span className="text-green-700 text-sm sm:text-base">
                    Настройки успешно обновлены
                    </span>
                </div>
            </div>
        )}

        {error && (
            <div className="text-red-600 text-center">{error}</div>
        )}
        <div className="bg-white border rounded-lg">
            <div className="p-4 sm:p-6 border-b">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <h2 className="text-lg font-semibold flex items-center gap-2">
                        <RussianRuble /> Цены
                    </h2>
                    {!isEditingSettings && (
                        <Button
                        variant="outline"
                        className="text-[#2563eb] border-[#2563eb] hover:bg-blue-50 text-sm w-full sm:w-auto"
                        onClick={() => setIsEditingSettings(true)}
                        >
                            Редактировать
                        </Button>
                    )}
                </div>
            </div>
            <div className="p-6 space-y-6">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <Label>
                        Цена книги
                    </Label>
                    <div className='flex flex-row gap-2'>
                        <Input 
                            type='number' 
                            placeholder="Введите цену книги"
                            value={settingsData.bookPrice}
                            onChange={e =>
                                setSettingsData({ ...settingsData, bookPrice: e.target.value })
                            }
                            disabled={!isEditingSettings}
               />
                        ₽
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <Label>
                        Цена подписки
                    </Label>
                    <div className='flex flex-row gap-2'>
                        <Input 
                            type='number' 
                            placeholder="Введите цену подписки"
                            value={settingsData.subPrice}
                            onChange={e =>
                                setSettingsData({ ...settingsData, subPrice: e.target.value })
                            }
                            disabled={!isEditingSettings}
                        />
                        ₽
                    </div>
                </div>
                {isEditingSettings && (
                    <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                    <Button
                        onClick={handleSettingsSave}
                        className="bg-[#2563eb] hover:bg-blue-700 text-white w-full sm:w-auto"
                    >
                        <Save className="h-4 w-4 mr-2" />
                        Сохранить
                    </Button>
                    <Button
                        variant="outline"
                        onClick={() => {
                        // откатиться к данным с сервера
                        setIsEditingSettings(false);
                        setError(null);
                        setSettingsSaved(false);
                        setLoading(true);
                        authFetch(`${API_URL}/settings/admin/settings`, {
                            headers: {
                            "Authorization": `Bearer ${localStorage.getItem("token")}`
                            }
                        })
                            .then(r => r.json())
                            .then(d => {
                            setSettingsData({
                                bookPrice: d.settings.book_price || 0,
                                subPrice: d.settings.sub_price || 0,
                                platformPercent: d.settings.platform_percent || 0,
                                refPercent: d.settings.ref_percent || 0
                            });
                            })
                            .catch(() => setError("Ошибка при откате"))
                            .finally(() => setLoading(false));
                        }}
                        className="w-full sm:w-auto"
                    >
                        Отмена
                    </Button>
                    </div>
                )}
            </div>
        </div>
        <div className="bg-white border rounded-lg">
            <div className="p-4 sm:p-6 border-b">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <h2 className="text-lg font-semibold flex items-center gap-2">
                        <Percent /> Проценты
                    </h2>
                    {!isEditingSettings && (
                        <Button
                        variant="outline"
                        className="text-[#2563eb] border-[#2563eb] hover:bg-blue-50 text-sm w-full sm:w-auto"
                        onClick={() => setIsEditingSettings(true)}
                        >
                            Редактировать
                        </Button>
                    )}
                </div>
            </div>
            <div className="p-6 space-y-6">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <Label>
                        Процент с продаж 
                    </Label>
                    <div className='flex flex-row gap-2'>
                        <Input 
                            type='number' 
                            placeholder="Введите процент с продаж"
                            value={settingsData.platformPercent}
                            onChange={e =>
                                setSettingsData({ ...settingsData, platformPercent: e.target.value })
                            }
                            disabled={!isEditingSettings}
                        />
                        %
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <Label>
                        Процент рефералу
                    </Label>
                    <div className='flex flex-row gap-2'>
                        <Input 
                            type='number' 
                            placeholder="Введите процент рефералу"
                            value={settingsData.refPercent}
                            onChange={e =>
                                setSettingsData({ ...settingsData, refPercent: e.target.value })
                            }
                            disabled={!isEditingSettings}
                        />
                        %
                    </div>
                </div>
                {isEditingSettings && (
                    <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                    <Button
                        onClick={handleSettingsSave}
                        className="bg-[#2563eb] hover:bg-blue-700 text-white w-full sm:w-auto"
                    >
                        <Save className="h-4 w-4 mr-2" />
                        Сохранить
                    </Button>
                    <Button
                        variant="outline"
                        onClick={() => {
                        // откатиться к данным с сервера
                        setIsEditingSettings(false);
                        setError(null);
                        setSettingsSaved(false);
                        setLoading(true);
                        authFetch(`${API_URL}/settings/admin/settings`, {
                            headers: {
                            "Authorization": `Bearer ${localStorage.getItem("token")}`
                            }
                        })
                            .then(r => r.json())
                            .then(d => {
                            setSettingsData({
                                bookPrice: d.settings.book_price || 0,
                                subPrice: d.settings.sub_price || 0,
                                platformPercent: d.settings.platform_percent || 0,
                                refPercent: d.settings.ref_percent || 0
                            });
                            })
                            .catch(() => setError("Ошибка при откате"))
                            .finally(() => setLoading(false));
                        }}
                        className="w-full sm:w-auto"
                    >
                        Отмена
                    </Button>
                    </div>
                )}
            </div>
        </div>
    </div>
  );
}